import React from 'react';
import { isMobile } from '@/biz/tool';
import axiosInstance from '@/apis/axiosInstance';
import WebModal from '@/components/web/components/Modal';
import BottomDrawer from '@/components/web/components/BottomDrawer';

interface Props {
  openModal: boolean;
  onCloseModal: () => void;
}

const ModalAfterRelease: React.FC<Props> = ({ openModal, onCloseModal }) => {
  const title = 'Learn the basics';

  const setLearnTheRopes = async () => {
    await axiosInstance.post('/influencer/onboarding/learnTheRopes', {});
  };

  const closeModal = () => {
    onCloseModal();
    setLearnTheRopes();
  };

  return isMobile() ? (
    <BottomDrawer
      title={title}
      visible={openModal}
      handleClose={closeModal}
      isShowFooter={false}
      rootClassName="!z-[9999]"
    >
      <ModalAfterReleaseContent />
    </BottomDrawer>
  ) : (
    <WebModal
      title={title}
      visible={openModal}
      handleClose={closeModal}
      isShowFooter={false}
      width={720}
    >
      <ModalAfterReleaseContent />
    </WebModal>
  );
};

export default ModalAfterRelease;

const ModalAfterReleaseContent = () => {
  return (
    <div className="w-full max-h-[360px] md:h-[360px] mt-4">
      <iframe
        className="w-full h-[200px] md:h-full rounded-lg"
        src="https://www.youtube.com/embed/BHy8bErn9cA?si=7oRlo-_ltqhHwhFr"
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>
    </div>
  );
};
